import { LocationDTO, SourceLocationDTO } from "../apiclient/ApiDtos";

export type LocationType = 'source' | 'destination'
export type TravellerType = 'Local' | 'Foreigner';

export default class SearchCriteria {
    sourceLocation:SourceLocationDTO; 
    destinationLocation:LocationDTO; 
    isoDateString:string;
    numberOfSeats:number;
    travellerType:TravellerType;
    isSmallCar:boolean;

    constructor(sourceLocation:SourceLocationDTO, destinationLocation:LocationDTO, 
        isoDateString:string, numberOfSeats:number, travellerType:TravellerType, isSmallCar:boolean) {
        
        this.sourceLocation = sourceLocation;
        this.destinationLocation = destinationLocation;
        this.isoDateString = isoDateString;
        this.numberOfSeats = numberOfSeats;
        this.travellerType = travellerType;
        this.isSmallCar = isSmallCar;
    }

    withDate(date:string):SearchCriteria {
        return new SearchCriteria(this.sourceLocation, this.destinationLocation, 
            date, this.numberOfSeats, this.travellerType, this.isSmallCar);
    }
}

